import React, { useState } from "react";
import Sidebar from "./components/sidebar/sidebar";
import Header from "./components/header/header";

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
     <div className={`app-wrapper ${mobileOpen ? "mobile-menu-open" : ""}`}>
      <Sidebar
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
      />
      {mobileOpen && (
        <button
          className="sidebar-overlay"
          type="button"
          aria-label="Close navigation menu"
          onClick={() => setMobileOpen(false)}
        />
      )}
      <div className={`main-section ${collapsed ? "collapsed" : ""}`}>
        <Header
          onToggle={() => {
            if (window.innerWidth <= 1024) {
              setMobileOpen((isOpen) => !isOpen);
            } else {
              setCollapsed((isCollapsed) => !isCollapsed);
            }
          }}
        />
        <div className="page-content">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
